export default __webpack_public_path__ + "static/media/11.c9a01266.webp";